// extracted by mini-css-extract-plugin
module.exports = {"Quiz":"Quiz_Quiz__2q2Tg","QuizWrapper":"Quiz_QuizWrapper__3Cpf0"};